import React from "react";
import MainLayout from "../../components/MainLayout/MainLayout";
import apiPageFirstBlock from "../../assets/images/ShotQualityApiFirstBlock.gif";
import apiPageSecondBlock from "../../assets/images/build_basketXshooter.png";
import GreenTick from "../../assets/images/green-tick.png";
import Image from "next/image";
import Head from "next/head";
import Link from "next/link";
import { appServerSideProps } from "../../utils/getAppService";
import Utils from "../../utils/Utils";
import { discordLink } from "../../constants/main";

const advancedDataList = [
  {
    heading: "Play by Play",
    value:
      "Comprehensive box score data, play-by-play insights, advanced defender metrics, and shooter analysis for NBA, NCAAM, WNBA, and over 10 international leagues.",
  },
  {
    heading: "Top Defender Metrics",
    value: "Each play includes key data:",
    list: [
      "Distance to the Closest Defender (Feet)",
      "Height of the Closest Defender (Inches)",
      "Closest Defender Velocity to the Shooter (ft/s)",
      "Shooter Velocity to the Basket (ft/s)",
    ],
  },
  {
    heading: "Feature Store",
    value: "Key data components and advanced metrics available for integration.",
  },
  {
    heading: "Data Coverage",
    value:
      "Location data across more than a dozen leagues, including NBA, NCAAM, WNBA, and international leagues. For full details, refer to our Data Coverage documentation here.",
  },
];

const premiumOfferings = [
  {
    heading: "Daily Projections and Results",
    desc: "Sharp daily predictions based on odds to help you win delivered to your inbox and available on shotqualitybets.com.",
    base: true,
    premium: true,
  },
  {
    heading: "Betting Trend Finder",
    desc: "Filter extensive game data to find the trends that should be winning using SQ Predictive data. See past occurrences, projected vs actual results, and identify future game instances by team, conference, road splits, and more!",
    base: true,
    premium: true,
  },
  {
    heading: "Custom Model Builder",
    desc: "Take control of the data and build your own custom model in the ShotQuality sandbox.",
    base: true,
    premium: true,
  },
  {
    heading: "Scores, Standings, Team and Game Breakdowns",
    desc: "In depth analysis and modeling of projected standings, team performance, and game breakdowns.",
    base: true,
    premium: true,
  },
  {
    heading: "In-Depth Matchup Breakdowns",
    desc: "Dive into how teams compare in ShotQuality metrics, play-type styles, and regression statistics. Choose from today`s games or create your own custom matchup.",
    base: true,
    premium: true,
  },
  {
    heading: "ShotQuality Scores and API Access",
    desc: "Access to past and predicted ShotQuality scores through the API and shotqualitybets.com.",
    base: false,
    premium: true,
  },
];
const BetsApi = ({ user }) => {
  const emailSubject = encodeURIComponent("API Access Request");
  const emailBody = encodeURIComponent("👍I would like to learn about API access to ShotQuality");
  const mailTo = "hello@shotquality.com";
  const isTrader = Utils.isTrader(user);

  return (
    <>
      <Head>
        <title>Build with the best data in Basketball | ShotQualityBets API</title>
        <meta
          name="description"
          content="Unlock superior insights with ShotQualityBets API – your premier source for NBA, NCAA, and WNBA basketball data and analytics. Elevate your game strategy and betting decisions with the most comprehensive basketball data available."
        />
      </Head>

      <MainLayout>
        <main id="ContentBox">
          <div className="build-page">
            <div className="container">
              <div className="row">
                <div className="col-md-6 d-flex flex-column justify-content-center ">
                  <h1>Build with the best data in basketball </h1>
                  <p>
                    Connect to ShotQuality data for NBA, NCAA, and WNBA to create powerful tools and give you the edge.
                  </p>
                  <Link
                    href={"https://form.typeform.com/to/ZNOCZUaF"}
                    className="btn btn-secondary buttons-act "
                    style={{ color: "#fff", padding: "10px 15px" }}
                    target="_blank"
                  >
                    {" "}
                    Get Started
                  </Link>
                </div>
                <div className="col-md-6">
                  <img src={apiPageFirstBlock.src} width="630px" alt="" />
                </div>
              </div>
            </div>
            <div className="container-fluid advanced-data ">
              <div className="row pt-5 pb-4 m-auto" style={{ maxWidth: "90rem" }}>
                <div className="code-image col-md-4 col-12 d-flex align-items-center mb-5">
                  <img src={apiPageSecondBlock.src} width="630px" alt="" className="b-radius-2" />
                </div>
                <div className="col-md-8 col-12 ">
                  <h2 className="">Win more with advanced data</h2>
                  <div className="advanced-data-points">
                    {advancedDataList.map((data) => {
                      return <AdvancedDataView key={data.heading} data={data} />;
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="advanced-data-links container-fluid">
              <div className="row m-auto" style={{ maxWidth: "90rem" }}>
                <div className="links col-md-12 mb-5 mt-5 text-center">
                  <h3>🤖 API Reference</h3>
                  <p className="mb-2 fs-5 text-black">
                    A technical guide to connecting, querying, and leveraging ShotQuality data.{" "}
                  </p>
                  <Link
                    className="link btn btn-secondary text-black"
                    target="_blank"
                    href={"https://docs.api.shotquality.com/docs/introduction"}
                  >
                    Learn more {">"}
                  </Link>
                  <hr className="mt-5" />
                </div>
                {!isTrader && (
                  <>
                    <div className="links col-md-4 ">
                      <h3>🤝 Community</h3>
                      <p>
                        Join our community of sports analytics experts and learn how to tune your models and get the
                        edge.
                      </p>
                      <Link target="_blank" href={discordLink}>
                        <p className="link">Join Us {">"}</p>
                      </Link>
                    </div>
                    <div className="links col-md-4">
                      <h3>📊 Expert Tips</h3>
                      <p>
                        See how data science experts are using ShotQuality Data to make smarter predictions and help
                        them win.
                      </p>
                      <Link target="_blank" href={discordLink}>
                        <p className="link">See more {">"}</p>
                      </Link>
                    </div>
                  </>
                )}
              </div>
            </div>
            {!isTrader && (
              <div className="premium-section row">
                <div className="container d-xl-flex flex-xl-column d-sm-flex flex-sm-column justify-content-center">
                  <div className="premium-section-header d-flex justify-content-center">
                    <h2> ShotQuality Premium</h2>
                  </div>
                  <div className="premium-section-offerings">
                    {premiumOfferings.map((data, index) => {
                      return (
                        <ShotQualityPremiumOffering
                          key={index}
                          index={index}
                          data={data}
                          length={premiumOfferings.length}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </MainLayout>
    </>
  );
};
const AdvancedDataView = ({ data }) => {
  return (
    <>
      <div className="d-flex gap-1 fs-5">
        <div>🏀</div>
        <div style={{ color: "black" }}>
          <span style={{ "font-weight": "bold" }}> {data.heading}</span>: {data.value}
          {data.list && (
            <ul className="mt-3">
              {data.list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

const ShotQualityPremiumOffering = ({ data, index, length }) => {
  return (
    <div className="offering">
      <div className="mt-5 d-flex flex-row mb-3">
        <div className="col-md-7">
          <h4>{data.heading}</h4>
          <p className="mt-3">{data.desc}</p>
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-1 d-flex flex-column align-items-center">
          <p className="">Base</p>
          <div className="d-flex justify-content-center">
            {data.base ? <Image src={GreenTick.src} height={30} width={30} alt="tick" /> : <span>&#x2014;</span>}
          </div>
        </div>
        <div className="col-md-1 d-flex flex-column align-items-center">
          <p>Premium</p>
          <div className="d-flex justify-content-center">
            {data.premium ? <Image src={GreenTick.src} height={30} width={30} alt="tick" /> : <span>&#x2014;</span>}
          </div>
        </div>
      </div>
      {index < length - 1 ? <div className="m-3" style={{ borderBottom: "0.3px solid grey" }}></div> : <div></div>}
    </div>
  );
};
export default BetsApi;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return { props: { user } };
});
